
import { queryParamToObject } from '@util/parseQueryUtils';
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { Location as RouterLocation } from 'vue-router'
import SettingsTitleBar from '@components/settings/SettingsTitleBar.vue';
import SettingsFooter from '@components/settings/SettingsFooter.vue';
import AppPage from '@components/new-styleguide/AppPage.vue';
import AppEditableHeader from '@components/new-styleguide/AppEditableHeader.vue';
import AppContent from '@components/new-styleguide/AppContent.vue';
import { Location, ZoneMutation } from '@/generated-clients/myTrips';
import ZoneSelect from '@components/settings/zone/ZoneSelect.vue';
import goBackWithFallback from '@util/goBackWithFallback';
import { RouterFrom } from '@/router/Routes';

const SettingsModule = namespace('Settings');
const TriplogModule = namespace('Triplog');
const RouterModule = namespace('Router');

@Component({
  name: 'ZoneAdd',
  components: {
    AppPage,
    AppContent,
    AppEditableHeader,
    SettingsTitleBar,
    SettingsFooter,
    ZoneSelect
  }
})
export default class ZoneAdd extends Vue {
  @SettingsModule.Action('createZone')
  private createZone;

  @TriplogModule.Getter('getLatestFilteredLocation')
  private latestFilteredLocation: Location;

  @RouterModule.State('from')
  private from: RouterFrom;

  private zone: ZoneMutation = {
    name: '',
    latitude: null,
    longitude: null,
    radius: 100,
    shortParkingZoneNotification: true
  };

  private disabled = false;
  private currentMovement = false;
  private errorMessage = '';

  async created() {
    const location: Location = (this.initialLocationAddress)
        ? this.initialLocationAddress.location
        : this.latestFilteredLocation || { latitude: 48.208442578127546, longitude: 16.374201141067804 };

    this.zone = {
      ...this.zone,
      latitude: location.latitude,
      longitude: location.longitude
    }
  }

  get backButton() {
    return { text: (this.queryTripId) ? 'Zurück zur Fahrt' : 'Zurück zu Zielen', location: { ...this.backLocation } };
  }

  get nameError() {
    return !this.zone.name;
  }

  get errorsExist() {
    return this.nameError;
  }

  private async submit() {
    if (!this.errorsExist) {
      this.disabled = true;

      try {
        await this.createZone({ zone: this.zone });
        goBackWithFallback(this.$router, !!this.from.name, this.backLocation);
      } catch (error) {
        this.errorMessage = 'Fehler beim Speichern der Zone. Bitte versuchen sie es später erneut.'
      } finally {
        this.disabled = false;
      }
    }
  }

  get queryTripId() {
    return this.$route.query.tripId;
  }

  get backLocation(): RouterLocation {
    return (this.queryTripId)
        ? { name: 'myTripsEdit', params: { id: this.queryTripId as string } }
        : { name: 'zonesOverview' };
  }

  get queryLocationAddress() {
    return this.$route.query.locationAddress;
  }

  get initialLocationAddress() {
    return (this.queryLocationAddress)
        ? queryParamToObject(this.queryLocationAddress as string)
        : null;
  }

  get initialAddress() {
    return (this.initialLocationAddress)
        ? this.initialLocationAddress.address
        : null;
  }
}
